import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const snapchat: Platform = {
  id: 'snapchat',
  name: 'Snapchat',
  iconIndex: PlatformRegistry.snapchat.index,
  color: PlatformRegistry.snapchat.color,
  buildUrl: (content: ShareContent): string => {
    return buildShareUrl('https://www.snapchat.com/share', {
      url: content.url,
    });
  },
};

